import {deleteArea} from '../../../services/adminService'
import {adminListActions} from '../admin'
import getAreaListAction from './getAreaListAction'

const deleteAreaAction = (payload, data) => {
  return (dispatch) => {
    dispatch(adminListActions.deleteAreaRequest())
    deleteArea(payload).then((res) => {
      if (res.status === 200) {
        if (data.includes('Undefined Area')) {
          dispatch(adminListActions.setMessageData({message: 'Area(s) deleted but Undefined Area cannot be deleted.', status: 'success'}))
        } else {
          dispatch(adminListActions.setMessageData({message: 'Area(s) Deleted Successfully.', status: 'success'}))
        }
        dispatch(getAreaListAction())
      }
      dispatch(adminListActions.deleteAreaSuccess(res))
    }).catch((error) => {
      dispatch(adminListActions.deleteAreaFailure(error))
    })
  }
}

export default deleteAreaAction
